/* eslint-disable prettier/prettier */
import { computed } from "vue"
import { useStore } from "vuex"


const useAuth = () =>{
   const store = useStore()
   const loginUser = async (user) =>{
       const resp =await store.dispatch("auth/loginUser", user)
       return resp
   }
   const checkAuthStatus = async()=>{
       const resp = await store.dispatch("auth/checkAuthentication")
       return resp
   }
   const logout=()=>{
       store.commit("auth/logout")
   }

    return{
        loginUser,
        checkAuthStatus,
        authStatus: computed(()=>store.getters["auth/currentState"]),
        username: computed(()=>store.getters["auth/username"]),
        email: computed(()=>store.getters["auth/email"]),
        image: computed(() => store.getters["auth/image"]),
        rol:computed(() => store.getters["auth/rol"]),
        id_recinto:computed(() => store.getters["auth/id_recinto"]),
        nombre_recinto_penitenciario:computed(() => store.getters["auth/nombre_recinto_penitenciario"]),
        departamento_centro_penitenciario:computed(() => store.getters["auth/departamento_centro_penitenciario"]),
        departamento_supervisar:computed(() => store.getters["auth/departamento_supervisar"]),
        logout
    }
}
export default useAuth